<template>
  <new-user-form />
</template>

<script>
import NewUserForm from "@/components/3pl/Settings/UsersAndGroups/Users/NewUser/index";
export default {
  components: {
    NewUserForm,
  },
};
</script>

<style></style>
